export default {
	CATEGORIES: 'companies/:company_id/categories/',
	CATEGORIES_SORT: 'companies/:company_id/categories/sort/',
	PRODUCT_CATEGORIES: 'companies/:company_id/product-categories'
}
